export const classPhaseType = {
  preregistration: 1,
  registration: 2,
  progress: 3,
  custom: 4,
}
